export default __webpack_public_path__ + "static/media/data2.ade57bdd.png";